
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";




export const useLotesFuncion = () => {


    const { id } = useParams();
    const navigate = useNavigate();



    const handleNavegar = (url) => {
        navigate(`/admin/lote/${id}/${url}`)
    }



    const handleTrueFalse = (e, lote) => {
        e.stopPropagation();
        Swal.fire({
            title: 'Archivar Lote',
            text: `¿Esta Seguro De Archivar Lote?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        }).then( ( result ) => {
            if(result.value){
                Swal.fire({
                title: 'Esta a Punto De Archivar El Lote',
                text: `Si Archiva El Lote No Puede Volver A Activarlo Y La Fecha Fin Sera Modificada`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si, Archivar' 
            }).then( ( result ) => {
                if(result.value){
                    // cambioEstadoLote( lote.id );
                }
            });
            }
        });
    }



    const handleEliminarInfo = () => {
        Swal.fire({
            title: 'Eliminar Lote',
            text: `¿Esta seguro de eliminar lote?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        }).then( ( result ) => {
            // if(result.value){
            //     Swal.fire({
            //     title: 'Esta a Punto De Archivar El Lote',
            //     text: `Si Archiva El Lote No Puede Volver A Activarlo Y La Fecha Fin Sera Modificada`,
            //     icon: 'question',
            //     showCancelButton: true,
            //     confirmButtonText: 'Si, Archivar' 
            // }).then( ( result ) => {
            //     if(result.value){
            //         // cambioEstadoLote( lote.id );
            //     }
            // });
            // }
        });
    }



    return {
        handleNavegar,
        handleTrueFalse,
        handleEliminarInfo,
    }

}
